import React from "react";
import IconifyIcon from "../IconifyIcon";

interface CustomIconButtonProps {
  icon: string;
  onClick: () => void;
  iconSize?: number;
  disabled?: boolean;
}

const CustomIconButton = ({
  icon,
  onClick,
  iconSize = 18,
  disabled = false,
}: CustomIconButtonProps) => {
  return (
    <div
      style={{ width: 30, height: 30, color: "white", borderRadius: 15 }}
      className={`flex align-items-center justify-content-center ${
        disabled ? "disabled-bg" : "primary-bg"
      }`}
      onClick={disabled ? () => {} : onClick}
    >
      <IconifyIcon icon={icon} style={{ fontSize: iconSize }} />
    </div>
  );
};

export default CustomIconButton;
